module.exports = __webpack_public_path__ + "media/images/breakfast-e896d6c51ddced72e5612cbc13cc2cc4.png";